<!-- 盘点历史 -->

<template>
<div style="width:100%;height:100%;background-color:#f6f7fb;">
    <div v-if="$route.name==='exchangeWork'" class="exchangeWork">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="title_item left"><i>*</i><span>本班现金为收银员上交金额</span></div>
                        <div class="title_item left"><i>*</i><span>微信和支付宝直接查阅电子对账单（公众号-'店员宝'-'我的店铺'）</span></div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <!-- <th style="width:15%">开班员工</th> -->
                                <th style="width:15%">交班员工</th>
                                <th style="width:30%">交接班时间</th>
                                <th style="width:15%">总收入</th>
                                <th style="width:15%">退单</th>
                                <th style="width:25%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:workData.length>10}">
                                    <tr v-for="item in workData">
                                        <!-- <td style="width:15%" v-text="item.operatorName"></td> -->
                                        <td style="width:15%" v-text="item.closeUsername"></td>
                                        <td style="width:30%">
                                            <div v-if="item.id">
                                                <span>{{item.beginTime | numberToMonthDate('')}}</span>
                                                <span>~</span>
                                                <span>{{item.endTime | numberToMonthDate('')}}</span>
                                            </div>
                                        </td>
                                        <td style="width:15%">{{ item.turnInAmount }}<span style="color:red;" v-if="item.leaseAmount">(含租赁费:<b>{{ item.leaseAmount }}元</b>)</span></td>
                                        <td style="width:15%" v-text="item.refundAmount"></td>
                                        <td style="width:25%">
                                            <div v-if="item.id" class="btnInline">
                                                <span style="cursor:pointer;color:#9FB2D7;text-decoration: underline;" @click="$router.push({path:`/sys/${curStoreId}/exchangeWork/staffGrade`,query:{workShiftId:item.id,closeUsername:item.closeUsername,beginTime:item.beginTime,endTime:item.endTime}})">对账单</span>
                                                <span style="cursor:pointer;color:#9FB2D7;text-decoration: underline;" @click="cutSalesDetail(item)">销售明细</span>
                                                <span style="cursor:pointer;color:#9FB2D7;text-decoration: underline;" v-if="item.transactionEnable" @click="cutStockDetail(item)">库存记录</span>
                                                <!-- <span style="cursor:pointer;color:#9FB2D7;text-decoration: underline;" @click="getStaff(item)">员工销售</span> -->
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 分页器 -->
                <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:(curPage>0)}" @click="changePage(false)"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(curPage+1)"></span>
                                <span class="next flex flex-align-center flex-pack-center left" :class="{havePage:((curPage+1)<totalPage)}" @click="changePage(true)"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right" v-text="'第 '+(curPage+1)+' / '+totalPage+' 页'"></div>
                        <div class="totalPage flex flex-align-center right" v-text="'共'+totalElements+'条'"></div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            title="销售明细"
            :visible.sync="showPutAllMask1"
            @close="closeSaleDetail"
            size="tiny">
            <div class="putAllInner">
                <!-- <div class="salesMsg left"> -->
                    <!-- <div class="changeWorkMsgItem">
                        <span class="name" style="fontSize:16px;fontWeight:600">总销售额</span>
                        <span class="val right" v-text="'￥'+salesData.turnInAmount/100"></span>
                    </div> -->
                    <!-- <div class="salesInner"> -->
                        <!-- <div class="changeWorkMsgItem">
                            <span class="name">上缴金额：</span>
                            <span class="val right" v-text="'￥'+(salesData.cashAmount+salesData.alipayCashAmount+salesData.wechatCashAmount)/100"></span>
                        </div> -->
                        <!-- <div class="changeWorkMsgItem">
                            <span class="name">现金：</span>
                            <span class="val right" v-text="'￥'+salesData.cashAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">线下支付宝：</span>
                            <span class="val right" v-text="'￥'+salesData.alipayCashAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">线下微信：</span>
                            <span class="val right" v-text="'￥'+salesData.wechatCashAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">支付宝：</span>
                            <span class="val right" v-text="'￥'+salesData.alipayAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">微信：</span>
                            <span class="val right" v-text="'￥'+salesData.wechatAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">优惠券抵扣：</span>
                            <span class="val right" v-text="'￥'+salesData.couponAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">会员支付：</span>
                            <span class="val right" v-text="'￥'+salesData.memberAmount/100"></span>
                        </div> -->
                        <!-- <div class="changeWorkMsgItem">
                            <span class="name">会员充值：</span>
                            <span class="val color4" v-text="'￥'+salesData.memberDepositAmount/100"></span>
                        </div> -->
                    <!-- </div> -->
                <!-- </div> -->
                <div class="couponBox right">
                    <div class="changeWorkTitle" style="margin-bottom:10px;font-weight:600;">优惠券核销统计</div>
                    <div class="putAllTableBox">
                        <div v-for="(item,ind) in salesData.coupons">
                            <div class="couponItem clearfix">
                                <span class="name left" v-text="item.productName"></span>
                                <span class="price right" v-text="'￥'+item.amount/100"></span>
                                <span class="number right" v-text="'X'+item.quantity" ></span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="netCostMsg left">
                    <div class="changeWorkMsgItem">
                        <span class="name" style="fontSize:16px;fontWeight:600">网费</span>
                        <span class="val right" v-text="'￥'+salesData.cost.turnInAmount/100"></span>
                    </div>
                    <div class="netCostInner">
                        <div class="changeWorkMsgItem">
                            <span class="name">现金：</span>
                            <span class="val right" v-text="'￥'+salesData.cost.cashAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">线下支付宝：</span>
                            <span class="val right" v-text="'￥'+salesData.cost.alipayCashAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">线下微信：</span>
                            <span class="val right" v-text="'￥'+salesData.cost.wechatCashAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">支付宝：</span>
                            <span class="val right" v-text="'￥'+salesData.cost.alipayAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">微信：</span>
                            <span class="val right" v-text="'￥'+salesData.cost.wechatAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">优惠券抵扣：</span>
                            <span class="val right" v-text="'￥'+salesData.cost.couponAmount/100"></span>
                        </div>
                        <div class="changeWorkMsgItem">
                            <span class="name">会员支付：</span>
                            <span class="val right" v-text="'￥'+salesData.cost.memberAmount/100"></span>
                        </div>
                    </div>
                </div> -->
                <div class="goodTypeBox left">
                    <div class="changeWorkTitle" style="margin-bottom:10px;font-weight:600;">分类列表</div>
                    <div class="putAllTableBox">
                        <div class="cost-cashAmount">
                            <span class="name">火星网费：</span>
                            <span class="val">￥{{salesData.cost.cashAmount | toFixedNum}}</span>
                        </div>
                        <div class="cost-cashAmount">
                            <span class="name">会员支付网费:</span>
                            <span class="val">￥{{salesData.net.amount | toFixedNum}}</span>
                            <span class="name">,数量:</span>
                            <span class="val">{{salesData.net.qty}}</span>
                        </div>
                        <div class="cost-cashAmount">
                            <span class="name">会员充值金额：</span>
                            <span class="val">￥{{(salesData.memberDepositAmount)/100 | toFixedNum}}</span>
                        </div>
                        <el-collapse @change="getNowTypeProducts" :value="nowTypeName" accordion>

                            <!-- <el-collapse-item  :title="'网费：￥'+salesData.cost.cashAmount/100">
                            </el-collapse-item> -->
                            <el-collapse-item v-for="(item,ind) in rentData" :name="item.typeName" :key="'rent'+ind">
                                <template slot="title">
                                    {{item.typeName}}：￥{{item.amount | toFixedNum}}
                                </template>
                                <div class="goodItem clearfix" v-for="bigGood in item.leaseItemList">
                                    <span class="left" v-text="bigGood.qty+' × '+bigGood.name"></span>
                                    <span class="right">￥{{bigGood.amount | toFixedNum}}</span>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item v-for="(item,ind) in salesData.itemDetails" :name="item.typeName" :key="'big'+ind">
                                <template slot="title">
                                    {{item.typeName}}：￥{{item.amount | toFixedNum}}
                                </template>
                                <div class="goodItem clearfix" v-for="bigGood in nowItem">
                                    <span class="left" v-text="bigGood.qty+' × '+bigGood.name"></span>
                                    <span class="right">￥{{bigGood.amount | toFixedNum}}</span>
                                </div>
                                <!-- <el-collapse>
                                    <el-collapse-item v-for="(smallItem,idx) in item.productTypes" :title="smallItem.typeName+'：￥'+smallItem.amount/100" :name="'small'+idx" :key="'small'+idx">
                                        <div class="goodItem clearfix" v-for="smallGood in smallItem.products">
                                            <span class="left" v-text="smallGood.quantity+' × '+smallGood.productName"></span>
                                            <span class="right" v-text="'￥'+smallGood.amount/100"></span>
                                        </div>
                                    </el-collapse-item>
                                </el-collapse> -->
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
                <!-- <div class="couponBox left">
                    <div class="changeWorkTitle" style="margin-bottom:10px;font-weight:600;">优惠券核销统计</div>
                    <div class="putAllTableBox">
                        <div v-for="(item,ind) in salesData.coupons">
                            <div class="couponItem clearfix">
                                <span class="name left" v-text="item.productName"></span>
                                <span class="price right" v-text="'￥'+item.amount/100"></span>
                                <span class="number right" v-text="'X'+item.quantity" ></span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="clear"></div>
                <!-- <div class="btnGroup">
                    <button type="button" @click="sales2Excel">导出Excel</button>
                </div> -->
            </div>
        </el-dialog>
        <el-dialog
            title="员工销售"
            :visible.sync="showPutAllMask2"
            size="tiny">
            <div class="putAllInner">
                <div class="putAllTableBox">
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:10%">序号</th>
                                    <th style="width:30%">员工名称</th>
                                    <th style="width:30%">订单数量</th>
                                    <th style="width:30%">销售金额</th>
                                </tr>
                            </thead>    
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,ind) in staffArr">
                                            <td style="width:10%"><span v-text="ind+1+pageSize*salesCurPage"></span></td>
                                            <td style="width:30%"><span v-text="item.creatorName"></span></td>
                                            <td style="width:30%"><span v-text="item.orderCount"></span></td>
                                            <td style="width:30%"><span v-text="item.totalAmount"></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btnGroup">
                    <button type="button" @click="staff2Excel">导出Excel</button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title="库存记录"
            :visible.sync="showStock"
            class="stock"
            size="tiny">
            <div class="putAllInner">
                <div class="putAllTableBox">
                        <table>
                            <thead>
                                <tr>
                                    <th style="width:10%">序号</th>
                                    <th style="width:30%">商品名</th>
                                    <th style="width:30%">分类名</th>
                                    <th style="width:30%">库存剩余</th>
                                </tr>
                            </thead>    
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table>
                                    <tbody>
                                        <tr v-for="(item,ind) in stockArr">
                                            <td style="width:10%"><span v-text="ind+1"></span></td>
                                            <td style="width:30%"><span v-text="item.productName"></span></td>
                                            <td style="width:30%"><span v-text="item.typeName"></span></td>
                                            <td style="width:30%"><span v-text="item.qty"></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                </div>
                <!-- <div class="btnGroup">
                    <button type="button" @click="staff2Excel">导出Excel</button>
                </div> -->
            </div>
        </el-dialog>
    </div>
    <router-view v-if="$route.name==='staffGrade'"></router-view>
</div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import {API_BASE_URL} from '@/urlConfig/index.js';
    export default{
        props:['curStoreId', 'pageSize'],
    	data () {
    		return {
                rentData:[],
                stockArr:[],
                showStock:false,
                nowTypeName:'',//当前所选择的分类的名字
                nowItem:[
                    // {
                    //     amount: 0,
                    //     name: "",
                    //     qty: 0,
                    //     seTypeName: "",
                    //     typeName: ""
                    // }
                ],//用户点击交班的分类的时候，所点击的分类下的商品
                showPutAllMask:false,//交班明细控制按钮
                showPutAllMask1:false,//销售明细控制按钮
                showPutAllMask2:false,//员工销售明细控制按钮
                workData:[],
                curPage: 0,//当前页，用于切换页码
                totalPage: 1,//总共页
                totalElements: 0,//总共条

                getBtn: true, // 控制翻页请求

                inventoryList:[],//交班明细
                workDetailId:'',//某班id

                salesData:{cost:'',net:{qty:0,amount:0},itemDetails:[{amount: 0,name: "",qty: 0,seTypeName: "",typeName: ""}]},//销售明细
                salesCurPage:0,//销售明细的当前页码

                staffArr:[],//员工销售明细
                curWorkData: {
                    "cashAmount":'',
                    "alipayAmount":'',
                    "wechatAmount":'',
                    "alipayCashAmount":'',
                    "wechatCashAmount":'',
                    "memberAmount":'',
                    "couponAmount":'',
                }, // 当前查看班次的数据

    		}
    	},
        methods: {
            cutStockDetail(item){
                this.$http({
                    url:"workStock/list",
                    method:"GET",
                    params:{
                        id:item.id,
                    }
                }).then(res=>{
                    console.log(res);
                    this.showStock = true;
                    this.stockArr = res.data;
                });
            },
            //关闭销售明细时的回调，用于清空当前销售明细的数据
            closeSaleDetail(){
                this.salesData = {cost:'',net:{qty:0,amount:0},itemDetails:[{amount: 0,name: "",qty: 0,seTypeName: "",typeName: ""}]};
                this.nowTypeName = "";
            },
            //获取当前分类下的商品销售情况
            getNowTypeProducts(name){
                this.nowItem = [];
                console.log(name);
                if(this.nowTypeName === name || name === ""){
                    this.nowTypeName = '';
                    return;
                }
                this.nowTypeName = name;
                this.$http({
                    url:"get-itemDetails",
                    method:"GET",
                    params:{
                        id:this.curWorkData.id,
                        storeId:this.curStoreId,
                        typeName:name
                    }
                }).then(res=>{
                    this.nowItem = res.data;
                    console.log(res);
                });
            },
            //列表翻页
            changePage: function ( boo ) {
                if ( boo ) {
                    if ( (this.curPage + 1) >= this.totalPage ) {
                        return;
                    }
                    this.curPage++;
                } else {
                    if ( this.curPage <= 0 ) {
                        return;
                    }
                    this.curPage--;
                }
                this.getWordData();
            },
            //获取交班列表
            getWordData(){
                if ( !this.getBtn ) {
                    return;
                }
                this.getBtn = false;
                this.$http.get('/workshift/list?storeId='+this.curStoreId+'&page='+this.curPage+'&pageSize='+this.pageSize).then((res)=>{
                    this.workData = res.data.workShifts;
                    this.totalPage = res.data.totalPages;
                    this.totalElements = res.data.totalElements;
                    if( this.workData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.workData.length; i < len; i++){
                            this.workData.push({})
                        }
                    }
                    for(let i = 0,len=this.workData.length;i<len;i++){
                        if(this.workData[i].id){
                            this.workData[i].turnInAmount = this.workData[i].turnInAmount.toFixed(2);
                            this.workData[i].cashAmount = this.workData[i].cashAmount.toFixed(2);
                            this.workData[i].wechatAmount = this.workData[i].wechatAmount.toFixed(2);
                            this.workData[i].alipayAmount = this.workData[i].alipayAmount.toFixed(2);
                            this.workData[i].memberAmount = this.workData[i].memberAmount.toFixed(2);
                            this.workData[i].wechatCashAmount = this.workData[i].wechatCashAmount.toFixed(2);
                            this.workData[i].alipayCashAmount = this.workData[i].alipayCashAmount.toFixed(2);
                        }
                    }
                    this.getBtn = true;
                }).catch(()=>{
                    this.getBtn = true;
                })
            },
            getRentInfo(id){
                return new Promise((resolve,reject)=>{
                    this.$http({
                        // url:`${API_BASE_URL}v1/call/lease/printing`,
                        url:`lease/printing`,
                        method:"GET",
                        params:{
                            id
                        }
                    }).then(res=>{
                        try {
				            this.rentData = res.data.printing;
                        } catch (error) {
                            console.log(error)				
                        }
                        resolve();
                    }).catch(err=>{
                        reject();
                    })
                })
            },
            //销售明细
            async cutSalesDetail( item ){
                this.curWorkData = item;
                try {
                    await this.getRentInfo(item.id);
                } catch (error) {
                    console.log("error",error);
                }
                this.$http.get('workshift/'+item.id+'/details').then((res)=>{
                    this.salesData = res.data;
                    this.showPutAllMask1 = true;
                })
            },
            //员工业绩
            getStaff(item){
                this.$http.get('workshift/'+item.id+'/staff').then((res)=>{
                    this.staffArr = res.data;
                    this.showPutAllMask2 = true;
                    for(let i = 0,len = this.staffArr.length;i<len;i++){
                        this.staffArr[i].totalAmount = this.staffArr[i].totalAmount.toFixed(2);
                    }
                })
            },
            // 销售导出excel
            sales2Excel: function () {
                this.$http.get('get-excel?id='+this.curWorkData.id).then((res)=>{
                    let types = res.data.types;
                    let coupons = res.data.coupons;

                    let domstr = `<table style="border-collapse: collapse;">`
                    domstr += `<tr>
                                <th style="font-size:18px">商品名称</th>
                                <th style="font-size:18px">售价</th>
                                <th style="font-size:18px">数量</th>
                                <th style="font-size:18px">总计</th>
                            </tr>`
                    for (var i = 0, len = types.length; i < len; i++) {
                        domstr += `<tr>
                                <td colspan="3" style="text-align:center;font-size:16px">---`+types[i].typeName+`---</td>
                                <td style="font-size:16px;color:red">￥`+types[i].amount/100+`</td>
                            </tr>`;
                        for (var j = 0, len2 = types[i].products.length; j < len2; j++) {
                            domstr += `<tr>
                                    <td style="border:1px solid #ccc;font-size:14px">`+types[i].products[j].productName+`</td>
                                    <td style="border:1px solid #ccc;font-size:14px">`+types[i].products[j].amount/(types[i].products[j].quantity*100)+`</td>
                                    <td style="border:1px solid #ccc;font-size:14px">`+types[i].products[j].quantity+`</td>
                                    <td style="border:1px solid #ccc;font-size:14px">`+types[i].products[j].amount/100+`</td>
                                </tr>`;
                        }
                    }

                    domstr += `
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="7" style="font-size:18px;font-weight:900;text-align:center">总销售额</td>
                            </tr>
                            <tr>
                                <td style="font-size:18px;">现金</td>
                                <td style="font-size:18px;">支付宝</td>
                                <td style="font-size:18px;">微信</td>
                                <td style="font-size:18px;">线下支付宝</td>
                                <td style="font-size:18px;">线下微信</td>
                                <td style="font-size:18px;">会员支付</td>
                                <td style="font-size:18px;">优惠券抵扣</td>
                            </tr>
                            <tr>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.cashAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.alipayAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.wechatAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.alipayCashAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.wechatCashAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.memberAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.couponAmount/100+`</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="border:1px solid #ccc;font-weight:900;font-size:18px">总销售额：</td>
                                <td style="border:1px solid #ccc;font-size:20px;color:red;font-weight:600">`+this.curWorkData.turnInAmount+`</td>
                            </tr>`

                    domstr += `
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="7" style="font-size:18px;font-weight:900;text-align:center">网费销售额</td>
                            </tr>
                            <tr>
                                <td style="font-size:18px;">现金</td>
                                <td style="font-size:18px;">支付宝</td>
                                <td style="font-size:18px;">微信</td>
                                <td style="font-size:18px;">线下支付宝</td>
                                <td style="font-size:18px;">线下微信</td>
                                <td style="font-size:18px;">会员支付</td>
                                <td style="font-size:18px;">优惠券抵扣</td>
                            </tr>
                            <tr>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.cost.cashAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.cost.alipayAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.cost.wechatAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.cost.alipayCashAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.cost.wechatCashAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.cost.memberAmount/100+`</td>
                                <td style="border:1px solid #ccc;font-size:16px">`+this.salesData.cost.couponAmount/100+`</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style="border:1px solid #ccc;font-weight:900;font-size:18px">总销售额：</td>
                                <td style="border:1px solid #ccc;font-size:20px;color:red;font-weight:600">`+this.salesData.cost.turnInAmount/100+`</td>
                            </tr>`

                    domstr += `
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="3" style="text-align:center;font-size:18px;font-weight:900">优惠券核销记录</td>
                            </tr>
                            <tr>
                                <td style="font-size:16px;font-weight:700;">优惠券名称</td>
                                <td style="font-size:16px;font-weight:700;">数量</td>
                                <td style="font-size:16px;font-weight:700;">总金额</td>
                            </tr>`
                    for (var i = 0, len = coupons.length; i < len; i++) {
                        domstr += `
                            <tr>
                                <td style="border:1px solid #ccc;font-size:14px">`+coupons[i].productName+`</td>
                                <td style="border:1px solid #ccc;font-size:14px">`+coupons[i].quantity+`</td>
                                <td style="border:1px solid #ccc;font-size:14px">`+coupons[i].amount/100+`</td>
                            </tr>`
                    }
                    domstr += `</table>`;

                    window.method5($(domstr)[0]);
                })
            },
            // 员工导出excel
            staff2Excel: function () {
                if ( !this.staffArr[0] ) {
                    this.$message({
                        message: '无数据可导出',
                        customClass: 'error'
                    })
                    return;
                }

                let data = this.staffArr;
                let domstr = `<table style="border-collapse: collapse;">`
                domstr += `<tr>
                            <th style="font-size:16px">员工名称</th>
                            <th style="font-size:16px">订单数量</th>
                            <th style="font-size:16px">销售金额</th>
                        </tr>`
                for (var i = 0, len = data.length; i < len; i++) {
                    domstr += `<tr>
                            <td style="border:1px solid #ccc;font-size:14px">`+data[i].creatorName+`</td>
                            <td style="border:1px solid #ccc;font-size:14px">`+data[i].orderCount+`</td>
                            <td style="border:1px solid #ccc;font-size:14px">`+data[i].totalAmount+`</td>
                        </tr>`;
                }

                domstr += `</table>`;

                window.method5($(domstr)[0]);
            }
        },
        created: function () {
            for (var i = 0; i < this.pageSize; i++) {
                this.workData.push({});
            }
        },
        activated: function () {
            this.getWordData();
            console.log(this.$route)
        }
    }
</script>
<style lang="scss">
    @import '../../../../../static/css/common.scss';
    @import '../../../tableTemplate/tableTem.scss';
	@import "exchangeWork.scss";
</style>



// WEBPACK FOOTER //
// exchangeWork.vue?5f26e5a6